/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchRepos.defs.js'
export { main as default } from './searchRepos.defs.js'
